import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const SEARCH_VALUE_FEATURE_KEY = 'searchValue';

export interface SearchValueState {
  searchValue: string;
}

export const initialSearchValueState = { searchValue: '' };

export const searchValueSlice = createSlice({
  name: SEARCH_VALUE_FEATURE_KEY,
  initialState: initialSearchValueState,
  reducers: {
    reset: (state) => {
      state = initialSearchValueState;
    },
    set: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload;
    },
    update: (state, action: PayloadAction<string>) => {
      const searchValueData = state.searchValue;
      Object.assign(searchValueData, action.payload);
    },
  },
});

export const searchValueReducer = searchValueSlice.reducer;
export const searchValueActions = searchValueSlice.actions;

export const selectSearchValueState = (
  rootState: unknown,
): SearchValueState => {
  if (
    Object.prototype.hasOwnProperty.call(rootState, SEARCH_VALUE_FEATURE_KEY)
  ) {
    return (rootState as { [SEARCH_VALUE_FEATURE_KEY]: SearchValueState })[
      SEARCH_VALUE_FEATURE_KEY
    ];
  }
  return { searchValue: '' };
};

export const selectSearchValue = (rootState: unknown): string =>
  selectSearchValueState(rootState).searchValue;
